export default __webpack_public_path__ + "static/media/AP_JC.37b65681.png";